var{toString:t}=Object.prototype,e=e=>e?.constructor??globalThis[t.call(e).slice(8,-1)]??e,l=(t,l)=>e(t)===l;export{l as default};